import {
  usePageNumberFromUrl,
  usePerPageValueFromUrl,
} from 'idsk-react-components';
import { ClientStatus } from '../../../model/ClientStatus';
import { useClient } from '../../../context/ClientStatusContext';
import {
  defaultPerPageValue,
  perPageDataArray,
} from '../../../constants/PaginationPerPageConstants';
import {
  getPredpisyCudziJazykPredpisy,
} from '../../../client/predpisyClient';
import PredpisCudziJazyk from '../../../model/PredpisCudziJazyk';

interface ReturnType {
  data: PredpisCudziJazyk;
  status: ClientStatus;
  pageNumberFromUrl: number;
  perPageValue: number;
}

export default (
  id: string|undefined,
  totalElements: number,
  getLastPage: (totalElements: number,
                  perPageValue: number) => number,
): ReturnType => {
  let { page: pageNumberFromUrl } = usePageNumberFromUrl();
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const lastPage = getLastPage(perPageValue, totalElements);
  if (pageNumberFromUrl > lastPage) { // when page is changed in url then max page is the last page
    pageNumberFromUrl = lastPage;
  }
  const {
    data,
    status,
  } = useClient(
    () => getPredpisyCudziJazykPredpisy(id, perPageValue, pageNumberFromUrl),
    [pageNumberFromUrl, perPageValue],
  );

  return <ReturnType>{
    data,
    status,
    pageNumberFromUrl,
    perPageValue,
  };
};
